import { render } from "./Configurations.vue?vue&type=template&id=d6d3a934"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__